import type { Filter } from '../typings'

import { useMemo } from 'react'

import { useTexts } from './useTexts'
import { useController } from './useController'

const filterValues: Filter[] = ['dispatched', 'selected']

export function useFilterOptions() {
  const texts = useTexts()
  const {
    data: { isSimulation },
  } = useController()

  // Options for filter RadioButton
  return useMemo(
    () =>
      filterValues.map(value => {
        const disabledForSimEnv = value === 'dispatched' && isSimulation
        const disabled = disabledForSimEnv

        let label: string
        let description: string

        switch (value) {
          case 'dispatched':
            label = texts.filterDispatchedLabel
            description = texts.filterDispatchedDescription
            break
          case 'selected':
            label = texts.filterSelectedLabel
            description = texts.filterSelectedDescription
            break
        }

        return {
          value,
          label,
          description,
          disabled,
        }
      }),
    [isSimulation, texts],
  )
}
